// Which "complete this debt" message a debt needs, if any (PB-326).
// Display only: nothing here changes how debts are saved or validated.

import type { DebtFormEntry } from '@/shared/api/types';

export type DebtPromptField = 'amountOwed' | 'repaymentAmount';

export interface DebtMissingPrompt {
  message: string;
  linkLabel: string;
  // Field the edit view should open at
  focusField: DebtPromptField;
}

export const DEBT_MISSING_PROMPT_COPY = {
  repaymentMissing: 'Add your repayment amount to complete this debt.',
  amountOwedMissing: 'Add the amount you owe to complete this debt.',
  bothMissing: "You haven't added an amount owed or a repayment amount for this debt yet.",
  addAmountLink: 'Add amount',
  addDetailsLink: 'Add details',
} as const;

// Missing means blank. A value of 0 counts as added.
export const isDebtAmountBlank = (value: unknown): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'string') return value.trim() === '';
  if (typeof value === 'number') return Number.isNaN(value);
  return false;
};

export function getDebtMissingPrompt(
  entry: Pick<DebtFormEntry, 'amountOwed' | 'repaymentAmount'>
): DebtMissingPrompt | null {
  const amountOwedMissing = isDebtAmountBlank(entry.amountOwed);
  const repaymentMissing = isDebtAmountBlank(entry.repaymentAmount);

  if (amountOwedMissing && repaymentMissing) {
    return {
      message: DEBT_MISSING_PROMPT_COPY.bothMissing,
      linkLabel: DEBT_MISSING_PROMPT_COPY.addDetailsLink,
      focusField: 'amountOwed',
    };
  }
  if (amountOwedMissing) {
    return {
      message: DEBT_MISSING_PROMPT_COPY.amountOwedMissing,
      linkLabel: DEBT_MISSING_PROMPT_COPY.addAmountLink,
      focusField: 'amountOwed',
    };
  }
  if (repaymentMissing) {
    return {
      message: DEBT_MISSING_PROMPT_COPY.repaymentMissing,
      linkLabel: DEBT_MISSING_PROMPT_COPY.addAmountLink,
      focusField: 'repaymentAmount',
    };
  }
  return null;
}
